// Thin, single-purpose wrapper so the tier screen's catch blocks all read the
// server's error message through the SAME path, and so that path can be
// regression-tested directly (see tests/unit/tierErrorMessage.spec.ts).
//
// This API's error responses carry `errorMessage`, never `message` — see
// `src/middleware/error.js` in the backend, which always ends with
// `res.status(statusCode).send({ errorCode: statusCode, errorMessage })`.
// Reading `error.response.data.message` (the wrong field — an earlier
// version of these forms did exactly that, copied from
// VoucherBatchForm.vue's identical bug) silently resolves to `undefined`,
// so every catch fell through to its own generic fallback string and
// discarded whatever the backend actually explained — e.g.
// tier_repo/createTier.js's Thai rank-clash message
// ("ลำดับระดับนี้ถูกใช้แล้ว").
//
// getErrorMessage (src/constants/errorMessages.js) is the codebase's
// existing canonical helper for this and already reads the right field —
// reuse it rather than re-implementing the extraction here.
// Relative import, not the "@/" webpack alias: this file is pulled in by
// tests/unit/tierErrorMessage.spec.ts, which runs under plain Playwright/
// Node (see playwright.unit.config.ts) — no webpack, so "@/..." does not
// resolve there and the test fails at module load ("Cannot find module
// '@/constants/errorMessages'") before a single assertion runs. Verified by
// running it with the alias import first.
import { getErrorMessage } from "../constants/errorMessages";

export function tierErrorMessage(error) {
  return getErrorMessage(error);
}
